import React from 'react'
import { Link } from 'react-router-dom'
import { SectionHeader_1, Card_5 } from '../../../component/landingComponent'
const LanguageModels = () => {
    return (
        <div className="integration-area section-spacing">
            <div className="container">
                <div className="integration-area-inner">
                    <div className="section-header">
                        <SectionHeader_1
                            title={`Language Models`}
                            subTitle={`Domain, Small and Custom Language Models`}
                            text={`Leverage our extensive expertise to build your own custom Language Models that align with your specific objectives and industry requirements. With our guidance, you can confidently navigate every stage of the development process—from data preparation and model training to fine-tuning and deployment.`}
                        />
                    </div>
                    <div className="integration-cards-wrapper">
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-first" role="tabpanel" aria-labelledby="pills-first-tab" tabIndex="0">
                                <div className="integration-cards">
                                    <div className="row gaap-20">
                                        <div className="col-md-3">
                                            <Link to="/language-models#how-do-we-do-it">
                                                <Card_5
                                                    icon={`/assets/img/tvicon/accuracy.png`}
                                                    title={`High accuracy`}
                                                    subTitle={`Small LMs for high accuracy, and reliability`}
                                                />
                                            </Link>
                                        </div>
                                        <div className="col-md-3">
                                            <Link to="/language-models#domain-context">
                                                <Card_5
                                                    icon={`/assets/img/tvicon/domain.png`}
                                                    title={`Domain context`}
                                                    subTitle={`Our Small LMs are enhanced with domain graph models for contextual conversations`}
                                                />
                                            </Link>
                                        </div>
                                        <div className="col-md-3">
                                            <Link to="/language-models#cost-effective">
                                                <Card_5
                                                    icon={`/assets/img/tvicon/cost-effective.png`}
                                                    title={`Cost-effective`}
                                                    subTitle={`Our Small LMs need less energy, less compute resources`}
                                                />
                                            </Link>
                                        </div>
                                        <div className="col-md-3">
                                            <Link to="/language-models#llms">
                                                <Card_5
                                                    icon={`/assets/img/tvicon/llm.png`}
                                                    title={`LLMs`}
                                                    subTitle={`Leverage our expertise in building your own Language Models`}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {LanguageModels}